import moment from 'moment';

export function formatDate(date: string, format: string = 'ddd, MMMM D h:mm A') {
  return moment(date).format(format)
}
